import type {Question} from '@cp/model';
import {questionCheckWithGpt} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useCheckQuestionWithGpt() {
  const {
    fn: checkQuestionWithGptFn,
    loading,
    error,
  } = useFunctionWrap(
    async (moduleId: string, questionId: string): Promise<Question> =>
      questionCheckWithGpt({moduleId, questionId}) as Promise<Question>,
  );

  return {
    checkQuestionWithGpt: checkQuestionWithGptFn,
    loading,
    error,
  };
}
